import { DependencyList, useRef } from 'react';
import { useDeepCompareEffect } from './useDeepCompareEffect';

/**
 * Auto scroll to element's bottom when deps changed.
 * Need to set height and overflow to scroll, if not element's height auto expanded
 * @param ref - Element ref
 * @param deps - Dependency List
 */
export const useScrollElementBottom = <T extends HTMLElement>(deps: DependencyList) => {
  const ref = useRef<T | null>(null);
  const scrollToBottom = () => {
    if (ref.current) {
      // We need to reset the height momentarily to get the correct scrollHeight
      ref.current.style.height = '0px';
      const scrollHeight = ref.current.scrollHeight;
      ref.current.style.height = scrollHeight + 'px';
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  };

  useDeepCompareEffect(() => {
    scrollToBottom();
  }, deps);

  return [ref, scrollToBottom] as const;
};
